import { ComposeOperation, SubjectViewState } from 'owa-mail-compose-store';

export default function createSubjectViewState(
    composeId: string,
    operation: ComposeOperation,
    subject: string,
    newContent: string
): SubjectViewState {
    return {
        selectionStart: -1,
        selectionEnd: -1,
        inputId: 'subjectLine' + composeId,
    };
}
